<template>
    <div class="card">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th class="w-100 d-sm-none">Продукт</th>
                        <th style="width: 100px" class="d-none d-sm-table-cell">Кнопка</th>
                        <th class="d-none d-sm-table-cell">Название</th>

                        <th v-feature="'loading'" style="width: 100px" class="d-none d-sm-table-cell">Вместимость</th>
                        <th v-feature="'loading'" colspan="2" class="d-sm-none">Вместимость</th>

                        <th class="action-buttons d-none d-sm-table-cell" />
                    </tr>
                </thead>
                <tbody>
                    <ValidationObserver v-for="(product, index) in products" ref="layout" :key="product.id" v-slot="{ invalid }" tag="tr">
                        <td class="d-sm-none">{{ product.product_number }} / {{ product.name }}</td>

                        <ValidationProvider v-errors.api tag="td" class="form-group d-none d-sm-table-cell" vid="product_number" rules="required">
                            <template v-if="index !== editableIndex">
                                <input v-model="product.product_number" maxlength="4" type="hidden">
                                {{ product.product_number }}
                            </template>

                            <input v-else v-model="editable.product_number" type="text" maxlength="4" class="form-control" placeholder="#" @keydown.enter="update">
                        </ValidationProvider>

                        <td class="d-none d-sm-table-cell truncate">{{ product.name }}</td>

                        <td v-if="hasLoading && product.is_composite">Рецепт</td>
                        <ValidationProvider v-else v-feature="'loading'" v-errors.api tag="td" class="form-group" vid="max" rules="integer|min_value:0|max_value:99999">
                            <template v-if="index !== editableIndex">
                                <input v-model="product.max" type="hidden">

                                <template v-if="product.max >= 0"><span class="text-nowrap">{{ product.max }} {{ 1 | unit }}</span></template>
                                <template v-else>–</template>
                            </template>

                            <volume-input v-else ref="max" v-model="editable.max" :unit="1" @keydown.enter="update" />
                        </ValidationProvider>

                        <td class="action-buttons text-right">
                            <button v-if="index === editableIndex" type="button" class="btn btn-link p-0" @click.prevent="stopEdit"><i class="tlm-icon-times text-danger" /></button>
                            <button v-if="index === editableIndex" type="button" class="btn btn-link p-0 ml-3" :disabled="invalid" @click.prevent="update"><i class="tlm-icon-check text-success" /></button>

                            <button v-else-if="hasLoading || !product.is_composite" type="button" class="btn btn-icon btn-edit" @click.prevent="startEdit(index)" />
                            <button type="button" class="btn btn-icon btn-remove d-none d-sm-inline" @click.prevent="remove(index)" />
                        </td>
                    </ValidationObserver>
                </tbody>

                <tfoot v-if="products.length === 0" class="no-one">
                    <tr>
                        <td colspan="4">Не добавлено ни одного продукта или рецепта.</td>
                    </tr>
                </tfoot>
            </table>

            <!-- Мобила -->
            <TheModal v-if="editable && $store.state.isMobile" class="d-sm-none" @close="stopEdit">
                <template v-slot:head>{{ editable.name }}</template>

                <ValidationObserver ref="editFormMobile" v-slot="{ invalid }" tag="form" @submit.prevent="updateMobile">
                    <ValidationProvider v-errors tag="div" class="form-group mb-3" vid="product_number" rules="required">
                        <label>#Кнопка</label>
                        <input v-model="editable.product_number" type="text" maxlength="4" class="form-control">
                    </ValidationProvider>

                    <ValidationProvider v-if="hasLoading && !editable.is_composite" v-errors.api tag="div" class="form-group mb-4" vid="max" rules="required|integer|min_value:1|max_value:99999">
                        <label>Вместимость</label>
                        <volume-input v-model="editable.max" :unit="1" class="w-100" />
                    </ValidationProvider>

                    <button type="submit" :disabled="invalid" class="btn btn-primary btn-lg-192 mb-3">Сохранить</button>

                    <button type="button" class="btn btn-outline-danger btn-lg-192" @click.prevent="remove(editableIndex)">Удалить</button>
                </ValidationObserver>
            </TheModal>
        </div>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VolumeInput from '@/components/VolumeInput'
import TheModal from '@/components/TheModal'

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        VolumeInput,
        TheModal
    },

    props: {
        products: {
            type: Array,
            default: _ => ([])
        },
        hasLoading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            editableIndex: null,
            editable: null
        }
    },

    methods: {
        startEdit(index) {
            this.editable = { ...this.products[index] }
            this.editableIndex = index
        },

        stopEdit() {
            this.editableIndex = null
            this.editable = null
        },

        async updateMobile(event, a) {
            const isValid = await this.$refs.editFormMobile.validate()

            if (!isValid) {
                return
            }

            this.$emit('update', {
                index: this.editableIndex,
                product_number: this.editable.product_number,
                max: this.editable.max
            })

            this.stopEdit()
        },

        async update() {
            const isValid = await this.$refs.layout[this.editableIndex].validate()

            if (!isValid) {
                return
            }

            this.$emit('update', {
                index: this.editableIndex,
                product_number: this.editable.product_number,
                max: this.editable.max
            })

            this.stopEdit()
        },

        remove(index) {
            this.$emit('remove', index)
            this.stopEdit()
        }
    }
}
</script>
